import { fileViewerAtom, previewKeyAtom } from 'js/file_viewer/core/atoms/atom';
import { isFullScreenAtom } from 'js/file_viewer/core/atoms/ui/general';
const isDocSidebarOpenPreferenceAtom = fileViewerAtom(false);
/**
 * Whether the doc thumbnail sidebar should be open for relevant preview types
 * (i.e. multi-page preview types like docs and presentations).
 * This gets persisted across the File Viewer session.
 */
export const isDocSidebarOpenAtom = fileViewerAtom((get) => {
    const isFullScreen = get(isFullScreenAtom);
    return isFullScreen ? false : get(isDocSidebarOpenPreferenceAtom);
}, (_get, set, isDocSidebarOpen) => {
    set(isDocSidebarOpenPreferenceAtom, isDocSidebarOpen);
});
export const docPasswordAttemptsAtom = previewKeyAtom(0);
export const docCurrentPageIndexAtom = previewKeyAtom(0, (_get, _set, _getPreviewKeyAtom, _setPreviewKeyAtom, pageIndex, pageCount) => {
    if (pageIndex < 0) {
        pageIndex = 0;
    }
    else if (pageCount && pageIndex >= pageCount - 1) {
        pageIndex = pageCount - 1;
    }
    return pageIndex;
});
export const docPageNavigationAtom = previewKeyAtom(undefined);
//# sourceMappingURL=doc.preenvesnextjs.map
